// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import { Avatar, Heading } from '@quickmd-llc/design-system'
import { useDailyVisit } from 'pages/WaitingRoom/daily/hooks/useDailyVisit'

export function InPersonVisitPlaceholder() {
  const { patientWithVisitInfo } = useDailyVisit()
  const { FirstName, LastName, ImageUrl } = patientWithVisitInfo || {}

  return (
    <div className='flex min-h-[400px] w-full flex-1 flex-col items-center justify-center gap-sp-2 bg-deep-navy-5 shadow-md'>
      {/*
       // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
      <Avatar name={`${FirstName ?? ''} ${LastName ?? ''}`.trim()} src={ImageUrl} size='xxl' />
      <Heading level='h3'>In-person visit</Heading>
    </div>
  )
}

export default InPersonVisitPlaceholder
